import styled from 'styled-components'

export const SwitchLabel = styled.label`
   font-size: 18px;
   color: ${props => props.theme.normalColor};
   margin-left: 10px;
   user-select: none;
   cursor: pointer;
`
